import {
  FETCH_PAYOUT_ATTRIBUTES_SUCCESS,
  MASSPAY_WITHDRAW_CLEAR,
  MASSPAY_WITHDRAW_FAILED,
  MASSPAY_WITHDRAW_SUCCESS,
  UPDATE_PAYOUT_MAX_AMOUNT
} from "../../store/actions/ActionConstant";
import { FETCH_PAYOUT_DRAFT_FAILURE } from "../../store/actions/ActionConstant";
import { UPDATE_PAYOUT_ATTRIBUTE_VALUE } from "../../store/actions/ActionConstant";
import { CONFIRM_PAYOUT_DRAFT_SUCCESS } from "../../store/actions/ActionConstant";
import { CONFIRM_PAYOUT_DRAFT_START } from "../../store/actions/ActionConstant";
import { CONFIRM_PAYOUT_DRAFT_FAILURE } from "../../store/actions/ActionConstant";
import { FETCH_PAYOUT_DRAFT_START } from "../../store/actions/ActionConstant";
import { FETCH_PAYOUT_DRAFT_SUCCESS } from "../../store/actions/ActionConstant";
import { FETCH_PAYOUT_ATTRIBUTES_START } from "../../store/actions/ActionConstant";
import { FETCH_PAYOUT_ATTRIBUTES_FAILURE } from "../../store/actions/ActionConstant";
import {
  INITIATE_PAYOUT_START,
  INITIATE_PAYOUT_SUCCESS,
  INITIATE_PAYOUT_FAILURE,
  FETCH_PAYOUT_SERVICES_START,
  FETCH_PAYOUT_SERVICES_SUCCESS,
  FETCH_PAYOUT_SERVICES_FAILURE,
  UPDATE_PAYOUT,
  INITIATE_PAYOUT_TABLE,
  REFRESH_UNIQUEID,
  WITHDRAWAL_CONFIRM_DOWNLOAD_START,
  WITHDRAWAL_CONFIRM_DOWNLOAD_END,
  UPDATE_PAYOUT_DUPLICATE_ATTRIBUTE_VALUE
} from "../actions/ActionConstant";

const initialState = {
  payout: {
    amount: "",
    destinationCurrency: "USD",
    destinationCountry: "USA",
    destinationToken: "",
    fee: 0,
    attrSetToken: "",
    loading: true,
    error: false,
  },
  payoutDraft: {
    data: {},
    loading: false,
    error: false,
    confirming: false,
  },
  services: {
    data: { companies: [] },
    loading: false,
    error: false,
  },
  attributes: {
    data: [],
    duplicatesAttributes:[],
    loading: false,
    error: false,
  },
  authentication: {
    data: {},
    loading: false,
    error: false,
  },
  payoutSuccess: {
    isSuccess: false,
    data: {},
  },
  payoutData: {
    unique_id: ''
  },
  downloadData:{
    loading:false,
    data:{}
  }
};

const PayoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case INITIATE_PAYOUT_START:
      return {
        ...state,
        authentication: {
          data: {},
          loading: true,
          error: false,
        },
        payoutData: {
          unique_id: '',
        },
      };
    case INITIATE_PAYOUT_TABLE:
      return {
        ...state,
        authentication: {
          data: {},
          loading: true,
          error: false,
        },
        payoutData: {
          unique_id: action.data,
        },
      };
    case INITIATE_PAYOUT_SUCCESS:
      return {
        ...state,
        authentication: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case INITIATE_PAYOUT_FAILURE:
      return {
        ...state,
        authentication: {
          data: {},
          loading: false,
          error: action.error,
        },
      };
    case FETCH_PAYOUT_SERVICES_START:
      return {
        ...state,
        services: {
          data: { companies: [] },
          loading: true,
          error: false,
        },
      };
    case FETCH_PAYOUT_SERVICES_SUCCESS:
      return {
        ...state,
        services: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case FETCH_PAYOUT_SERVICES_FAILURE:
      return {
        ...state,
        services: {
          data: { companies: [] },
          loading: true,
          error: action.error,
        },
      };
    case UPDATE_PAYOUT:
      return {
        ...state,
        payout: {
          ...state.payout,
          ...action.data,
        },
      };
    case REFRESH_UNIQUEID:
      return {
        ...state,
        payoutData: {
          unique_id: '',
        },
      };
    case UPDATE_PAYOUT_MAX_AMOUNT:
      return {
        ...state,
        payout: {
          ...state.payout,
          amount: ''
        },
        authentication: {
          ...state.authentication,
          loading: false,

        }
      };

    case FETCH_PAYOUT_ATTRIBUTES_START:
      return {
        ...state,
        attributes: {
          ...state.attributes,
          data: [],
          loading: true,
          error: false,
        },
      };
    case FETCH_PAYOUT_ATTRIBUTES_SUCCESS:
      return {
        ...state,
        attributes: {
          ...state.attributes,
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case FETCH_PAYOUT_ATTRIBUTES_FAILURE:
      return {
        ...state,
        attributes: {
          ...state.attributes,
          data: [],
          loading: true,
          error: action.error,
        },
      };
    case UPDATE_PAYOUT_ATTRIBUTE_VALUE:
      const at = state.attributes.data;
      let att = at;
      att[action.data.attr_index].value = action.data.value;

      return {
        ...state,
        attributes: {
          ...state.attributes,
          data: att,
          loading: false,
          error: state.attributes.error,
        },
      };

      case UPDATE_PAYOUT_DUPLICATE_ATTRIBUTE_VALUE:
      return {
        ...state,
        attributes: {
          ...state.attributes,
          duplicatesAttributes: action.data,
          loading: false,
          error: state.attributes.error,
        },
      };

    case FETCH_PAYOUT_DRAFT_START:
      return {
        ...state,
        payoutDraft: {
          data: {},
          loading: true,
          error: false,
        },
      };
    case FETCH_PAYOUT_DRAFT_SUCCESS:
      return {
        ...state,
        payoutDraft: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case FETCH_PAYOUT_DRAFT_FAILURE:
      return {
        ...state,
        payoutDraft: {
          data: {},
          loading: false,
          error: action.error,
        },
      };
    case CONFIRM_PAYOUT_DRAFT_START:
      return {
        ...state,
        payoutDraft: {
          ...state.payoutDraft,
          confirming: true,
        },
      };
    case CONFIRM_PAYOUT_DRAFT_SUCCESS:
      return {
        ...state,
        payoutDraft: {
          ...state.payoutDraft,
          confirming: false,
        },
        payoutData: {
          unique_id: '',
        },
      };
    case CONFIRM_PAYOUT_DRAFT_FAILURE:
      return {
        ...state,
        payoutDraft: {
          ...state.payoutDraft,
          confirming: false,
        },
      };
    case MASSPAY_WITHDRAW_SUCCESS:
      return {
        ...state,
        payoutSuccess: {
          isSuccess: true,
          data: action.data,
        },
      };
    case MASSPAY_WITHDRAW_FAILED:
      return {
        ...state,
        payoutSuccess: {
          isSuccess: false,
          data: {},
        },
      };
    case MASSPAY_WITHDRAW_CLEAR:
      return {
        ...state,
        payoutSuccess: {
          isSuccess: false,
          data: {},
        },
      };
    case WITHDRAWAL_CONFIRM_DOWNLOAD_START:
        return {
          ...state,
          downloadData:{
            loading:true,
            data:action.data
          }
        };
    case WITHDRAWAL_CONFIRM_DOWNLOAD_END:
          return {
            ...state,
            downloadData:{
              loading:false,
              data:{}
            }
          };
    default:
      return state;
  }
};

export default PayoutReducer;
